import { HomeBannerInfo } from '~/api/repository'

export class HomeBannerModel {
  private _title: string
  private _desktopThumbnail: string
  private _mobileThumbnail: string
  private _relatedLink: string

  constructor(data:HomeBannerInfo) {
    this._title = data.TI
    this._desktopThumbnail = data.TBPC
    this._mobileThumbnail = data.TBMB
    this._relatedLink = data.RLTDLNK
  }

  get title(): string {
    return this._title
  }

  get desktopThumbnail(): string {
    return this._desktopThumbnail
  }

  get mobileThumbnail(): string {
    return this._mobileThumbnail
  }

  get relatedLink(): string {
    return this._relatedLink
  }
}